import React from 'react';

export const PresentationPhotoGrid = ({ photos, altPrefix, imgHeightClass = 'h-64', testIdPrefix }) => (
  <div className="p-6">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {photos.map((photo, index) => (
        <div
          key={photo}
          data-testid={testIdPrefix ? `${testIdPrefix}-${index + 1}` : undefined}
          className="overflow-hidden rounded-lg border border-border-medium hover:border-brand-primary transition-all cursor-pointer"
          onClick={() => window.open(photo, '_blank')}
        >
          <img
            src={photo}
            alt={`${altPrefix} ${index + 1}`}
            className={`w-full ${imgHeightClass} object-cover hover:scale-105 transition-transform duration-300`}
          />
        </div>
      ))}
    </div>
    <p className="text-center text-text-secondary mt-6 text-sm">
      Clicca sulle foto per ingrandirle
    </p>
  </div>
);
